var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurriculumResumeSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.469 392.469",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M334.028,309.01V35.685c0-7.628-6.271-13.899-13.899-13.899H72.404 c-7.628,0-13.899,6.271-13.899,13.899v321.099c0,7.628,6.271,13.899,13.899,13.899h199.951v-50.747 c0-6.012,4.849-10.925,10.925-10.925H334.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M283.345,309.01h28.832V54.562c0-6.012-4.848-10.925-10.925-10.925H91.281 c-6.012,0-10.925,4.848-10.925,10.925v68.396h46.158c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H80.355 v30.772h19.782c6.012,0,10.925,4.848,10.925,10.925c0,6.012-4.848,10.925-10.925,10.925H80.355v140.735 c0,6.012,4.848,10.925,10.925,10.925h181.204v-28.962C272.485,313.859,277.333,309.01,283.345,309.01z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "294.271,358.529 322.004,330.796 294.271,330.796 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M239.903,176.808c0-6.206-5.042-11.184-11.184-11.184h-0.065l-22.691,42.408 c-4.073,7.628-15.063,7.628-19.265,0l-22.885-42.408c-6.206,0-11.184,5.042-11.184,11.184v65.939h87.273V176.808L239.903,176.808z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M169.244,317.802h16.162v-17.519c0-6.012,4.848-10.925,10.925-10.925 c6.012,0,10.925,4.848,10.925,10.925v17.519h16.162v-53.269h-54.109v53.269H169.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.267,110.481c10.537,0,19.071-8.598,19.071-19.071s-8.598-19.006-19.071-19.006 s-19.071,8.598-19.071,19.071S185.729,110.481,196.267,110.481z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.267,132.267c22.562,0,40.857-18.295,40.857-40.857s-18.295-40.857-40.857-40.857 S155.41,68.848,155.41,91.41S173.705,132.267,196.267,132.267z M196.267,72.404c10.537,0,19.071,8.598,19.071,19.071 s-8.598,19.006-19.071,19.006s-19.071-8.598-19.071-19.071S185.729,72.404,196.267,72.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M228.719,143.774h-6.659c-4.008,0-7.758,2.263-9.568,5.689l-16.226,30.255l-16.226-30.19 c-1.939-3.556-5.56-5.689-9.568-5.689h-6.659c-18.23,0-32.97,14.739-32.97,32.97v76.8c0,6.012,4.848,10.925,10.925,10.925h5.689 v64.129c0,6.012,4.848,10.925,10.925,10.925h75.895c6.012,0,10.925-4.848,10.925-10.925v-64.129h5.689 c6.012,0,10.925-4.848,10.925-10.925v-76.8C261.689,158.578,246.949,143.774,228.719,143.774z M223.289,317.802h-16.162v-17.519 c0-6.012-4.848-10.925-10.925-10.925s-10.925,4.848-10.925,10.925v17.519h-16.162v-53.269h54.109v53.269H223.289z M152.63,242.683 v-65.939c0-6.206,5.042-11.184,11.184-11.184l22.82,42.408c4.073,7.628,15.063,7.628,19.265,0l22.691-42.408h0.065 c6.206,0,11.184,5.042,11.184,11.184v65.939H152.63L152.63,242.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M320.129,0H72.404C52.687,0,36.719,15.968,36.719,35.685v321.099 c0,19.717,15.968,35.685,35.685,35.685h203.83c9.568,0,18.554-3.685,25.277-10.408l43.83-43.83 c6.723-6.723,10.408-15.709,10.408-25.277V35.685C355.814,15.968,339.846,0,320.129,0z M294.271,358.529v-27.733h27.733 L294.271,358.529z M272.485,319.935v50.747H72.404c-7.628,0-13.899-6.271-13.899-13.899V35.685c0-7.628,6.271-13.899,13.899-13.899 h247.661c7.628,0,13.899,6.271,13.899,13.899V309.01h-50.683C277.333,309.01,272.485,313.859,272.485,319.935z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurriculumResumeSvgrepoCom);
export default __webpack_public_path__ + "static/media/curriculum-resume-svgrepo-com.1c72a337576381d210df3bb426cf309b.svg";
export { ForwardRef as ReactComponent };